import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import { ApplicationState } from "../../../store";
import { IconComponent } from "../../reusable/simpleComponents";
import { TimelineState } from "../../../store/timeline/types";
import { LayoutState } from "../../../store/layouts/types";
import { triggerSpeedPicker } from "../../../store/layouts/actions";

const SpeedPickerUIComponent = () => {
    const { speedPlayback } = useSelector<ApplicationState, TimelineState>(state => state.timeline);
    const { speedPickerIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const dispatch = useDispatch();

    const handler = () => dispatch(triggerSpeedPicker(!speedPickerIsOpened));

    let speed = speedPlayback + 'x';
    if (speed[0] === '0') speed = speed.slice(1);

    return (
        <IconComponent classValue={speedPickerIsOpened ? 'speed-picker-icon player active icon' : 'speed-picker-icon player icon'}
                       handler={handler}
                       content={speed}
                       id={'speed-value'}
                       title="Set Playback Speed"
        />
    )
}

export default SpeedPickerUIComponent